import React, { useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '../pages';
import { isAuthenticated } from '../utils/auth';
import { bootstrapClientContext, setClientContext } from '../services/clientContext';
import ClientDashboard from './ClientDashboard';
import './client.scss';

// Loads the client's company context (no SelectContext UI) before showing the dashboard.
const ClientShell = ({ username, onLogout }) => {
  const [state, setState] = useState({ status: 'loading' });

  const bootstrap = useCallback(async () => {
    setState({ status: 'loading' });
    try {
      const { companies, companyId, financialYear } = await bootstrapClientContext();
      if (!companies || companies.length === 0) {
        setState({ status: 'no-company' });
        return;
      }
      setState({ status: 'ready', companies, companyId, financialYear });
    } catch (err) {
      setState({ status: 'error', message: err.message || 'Could not load your dashboard.' });
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const handleCompanyChange = async (companyId) => {
    setState((s) => ({ ...s, status: 'loading' }));
    try {
      const { financialYear } = await setClientContext(companyId);
      setState((s) => ({ ...s, status: 'ready', companyId, financialYear }));
    } catch (err) {
      setState({ status: 'error', message: err.message || 'Could not switch company.' });
    }
  };

  if (state.status === 'loading') {
    return <div className="cd-boot">Loading your dashboard…</div>;
  }
  if (state.status === 'no-company') {
    return (
      <div className="cd-boot">
        <h2>No company linked to your account</h2>
        <p>Contact your consultant to be added to a company.</p>
        <button type="button" className="cd-btn cd-btn--ghost" onClick={onLogout}>Log out</button>
      </div>
    );
  }
  if (state.status === 'error') {
    return (
      <div className="cd-boot">
        <h2>Something went wrong</h2>
        <p>{state.message}</p>
        <button type="button" className="cd-btn cd-btn--primary" onClick={bootstrap}>Try again</button>
        <button type="button" className="cd-btn cd-btn--ghost" onClick={onLogout}>Log out</button>
      </div>
    );
  }

  return (
    <ClientDashboard
      companies={state.companies}
      companyId={state.companyId}
      financialYear={state.financialYear}
      onCompanyChange={handleCompanyChange}
      username={username}
      onLogout={onLogout}
    />
  );
};

const ClientApp = ({ username, onLogout }) => (
  <Router>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          isAuthenticated()
            ? <ClientShell username={username} onLogout={onLogout} />
            : <Navigate to="/login" replace />
        }
      />
    </Routes>
  </Router>
);

export default ClientApp;
